import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <nav>
          <ul>
            <li><Link to="https://docs.weirdly.fun/weirdly-fun/about" className="active" target="_blank" rel="noopener noreferrer">About</Link></li>
            <li><Link to="https://docs.weirdly.fun/weirdly-fun/faq" target="_blank" rel="noopener noreferrer">FAQ</Link></li>
            <li><Link to="https://docs.weirdly.fun/weirdly-fun/privacy" target="_blank" rel="noopener noreferrer">Privacy</Link></li>
            <li><a href="https://docs.weirdly.fun/" target="_blank" rel="noopener noreferrer">Docs</a></li>
            <li><a href="https://x.com/WeirdlyFunApp" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="https://t.me/+2EL3buZGEHE3YTZh" target="_blank" rel="noopener noreferrer">Telegram</a></li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;